import { render, staticRenderFns } from "./OfferItemCreateOrUpdate.vue?vue&type=template&id=2e25641c&"
import script from "./OfferItemCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./OfferItemCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports